export const ERROR = {
  ERR_400: 400,
  ERR_401: 401,
  ERR_403: 403,
  ERR_404: 404,
  ERR_409: 409,
  ERR_500: 500,
};
